export const syncForkButtonEventPayload = {
  category: 'Branch Infobar',
  label: `ref_loc:fetch_upstream_dropdown`,
}
